import { defineComponent as f, useSlots as d, ref as m, openBlock as y, createBlock as p, unref as a, createSlots as c, withCtx as n, renderSlot as l, nextTick as v } from "vue";
import "./ghl-ui.es231.js";
import S from "./ghl-ui.es232.js";
const b = f({
  name: "UITabs",
  inheritAttrs: !1
}), x = f({
  ...b,
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "line"
    },
    defaultValue: {
      type: String,
      default: void 0
    },
    justifyContent: {
      type: String,
      default: ""
    },
    animated: {
      type: Boolean,
      default: !1
    },
    placement: {
      type: String,
      default: "top"
    },
    size: {
      type: String,
      default: "medium"
    }
  },
  emits: ["update:value"],
  setup(e, { expose: o }) {
    const s = d(), i = m(null);
    return o({ syncBarPosition: () => {
      v(() => {
        var t;
        return (t = i.value) == null ? void 0 : t.syncBarPosition();
      });
    } }), (t, u) => (y(), p(a(S), {
      ref_key: "tabsInstRef",
      ref: i,
      value: e.value,
      "onUpdate:value": u[0] || (u[0] = (r) => t.$emit("update:value", r)),
      type: e.type,
      animated: e.animated,
      placement: e.placement,
      "justify-content": e.justifyContent,
      "default-value": e.defaultValue,
      size: e.size,
      class: "hl-tabs"
    }, c({
      default: n(() => [
        l(t.$slots, "default")
      ]),
      _: 2
    }, [
      a(s).prefix ? {
        name: "prefix",
        fn: n(() => [
          l(t.$slots, "prefix")
        ]),
        key: "0"
      } : void 0,
      a(s).suffix ? {
        name: "suffix",
        fn: n(() => [
          l(t.$slots, "suffix")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["value", "type", "animated", "placement", "justify-content", "default-value", "size"]));
  }
}), z = x;
export {
  z as default
};
